export default {
  zh: {
    ruleContent: `
        1.邀请8个好友，能获得五个碎片，还会获得一个额外的头像框(15天） <br/>
        2.碎片可以去拼图活动，解锁拼图，兑换奖励 <br/>
        3.帮你助力的好友，必须是新用户，否则无法助力成功。（每个新用户只能助力一次） <br/>
        4.如果你想帮你的朋友助力，打开好友发送给你的链接，复制你好友的口令，在点击助力前把口令填写进去。（不填写口令或者口令错误，无法助力）
        `,
    noNull: '不能为空',
    noHelp: '无法助力，您不是新用户',
    noCode: '无效的邀请码',
    hadHelp: '已经助力过了',
    sucHelp: '助力成功',
    getSuc: '领取成功',
    copySuc: '复制成功',
    dl: '下载',
    cuUser: '当前邀请人数',
    enterI: '输入邀请码',
    friendI: '好友邀请码',
    clickHelp: '点击助力',
    meAlso: '我也要获得奖励',
    meAlso2: '我也想参加',
    acShow: '活动奖励展示',
    rule: '规则',
    letgo: '进入Hoby，帮助你的好友吧！'
  },
  en: {
    ruleContent: `
        1. Invite 8 friends, get 5 shards, and get an extra avatar frame (15 days) <br/>
        2. Fragments can go to puzzle activities, unlock puzzles, and exchange rewards <br/>
        3. The friend who helps you to help you must be a new user, otherwise you will not be able to help you succeed. (Each new user can only assist once) <br/>
        4. If you want to help your friend, open the link sent to you by your friend, copy your friend's code, and fill in the code before clicking Help. (If you do not fill in the code or the code is wrong, you cannot help)
        `,
    noNull: 'Can not be empty',
    noHelp: "Can't help, you are not a new user",
    noCode: 'invalid invitation code',
    hadHelp: 'already helped',
    sucHelp: 'help success',
    getSuc: 'Receive success',
    copySuc: 'copy successfully',
    dl: 'Download',
    cuUser: 'Current number of invitees',
    enterI: 'Enter invitation code',
    friendI: 'friend invitation code',
    clickHelp: 'Click to help',
    meAlso: 'I want to get a reward too',
    meAlso2: 'I would also like to attend',
    acShow: 'Activity reward display',
    rule: 'Rules',
    letgo: 'Enter Yayya and help your friends!'
  },
  ar: {
    ruleContent: `
        1- قم بدعوة 8 أصدقاء ، واحصل على 5 قطع ، واحصل على إطار أفاتار إضافي (15 يومًا) <br/>
        2- يمكن استعمال الأجزاء في أنشطة الألغاز ، وفتح الألغاز ، وتبادل المكافآت <br/>
        3- يجب أن يكون الأصدقاء الذين يساعدونك ， مستخدمين جدد ، وإلا فلن يتمكنوا من المساعدة بنجاح. (يمكن لكل مستخدم جديد مساعدة مرة واحدة فقط) <br/>
        4. إذا كنت ترغب في مساعدة صديقك ، افتح الرابط الذي أرسله إليك صديقك ، وانسخ كلمة مرور صديقك ، وقم بملء كلمة المرور قبل النقر فوق "مساعدة".  <br/>
        (إذا لم تقم بتعبئة كلمة المرور أو كانت كلمة المرور خاطئة ، فلا يمكنك "مساعدة ")        
        `,
    noNull: 'لا يمكن أن تكون فارغة',
    noHelp: 'فشل الدعوه ، لست مستخدمًا جديدًا',
    noCode: 'كلمة المرور غير صالحة',
    hadHelp: 'لا يمكن تكرار المساعدة',
    sucHelp: 'المساعدة بنجاح',
    getSuc: 'الحصول على النجاح',
    copySuc: 'النسخ بنجاح',
    dl: 'تنزيل',
    cuUser: 'عدد المدعوين',
    enterI: 'اكتب كلمة المرور',
    friendI: 'كلمة مرور الصديق',
    clickHelp: 'مساعدة',
    meAlso: 'أريد أيضًا أن أحصل على مكافآت',
    meAlso2: 'أريد أيضا المشاركة',
    acShow: 'عرض المكافآت',
    rule: 'القواعد',
    letgo: `ادخل الدردشة وساعد أصدقائك!`
  },
  uz: {
    ruleContent: `
    1. 8 do'stingizni taklif qiling, 5 dona parcha oling va qo'shimcha avatar ramkasi (15 kun) oling <br/>
    2. Parxalar jumboq faoliyatlariga borishi, jumboqlarni ochishi va mukofotlarni almashish uchun ishlatilishi mumkin <br/>
    3. Sizga yordam berayotgan do'stingiz yangi foydalanuvchi bo'lishi kerak, aks holda yordam berish muvaffaqiyatsiz bo'ladi. (Har bir yangi foydalanuvchi faqat bir marta yordam bera oladi) <br/>
    4. Do'stingizga yordam berish uchun do'stingiz yuborgan havolani oching, do'stingizning kodini nusxalab, yordamni bosishdan oldin kodni to'ldiring. (Agar kodni to'ldirmasangiz yoki kod noto'g'ri bo'lsa, yordam bera olmaysiz)
    `,
    noNull: "Bo'sh bo'lishi mumkin emas",
    noHelp: 'Yordam bera olmayman, siz yangi foydalanuvchi emassiz',
    noCode: "Noto'g'ri taklif kodi",
    hadHelp: 'allaqachon yordam bergan',
    sucHelp: 'yordam muvaffaqiyatli',
    getSuc: 'Muvaffaqiyatli olish',
    copySuc: 'Muvaffaqiyatli nusxalash',
    dl: 'Yuklab olish',
    cuUser: 'Hozirgi taklif qilingan foydalanuvchilar soni',
    enterI: 'Taklif kodi kiriting',
    friendI: "Do'stning taklif kodi",
    clickHelp: 'Yordam berish uchun bosing',
    meAlso: 'Men ham mukofot olishni xohlayman',
    meAlso2: 'Men ham qatnashmoqchiman',
    acShow: 'Faoliyat mukofotlari namoyishi',
    rule: 'Qoidalar',
    letgo: "Yayya-ga kirib, do'stlaringizga yordam bering!"
  },
  ru: {
    ruleContent: `
    1. Пригласите 8 друзей, получите 5 фрагментов и получите дополнительную рамку для аватара (15 дней) <br/>
    2. Фрагменты можно использовать в активностях с головоломками, разблокировать головоломки и обменивать на награды <br/>
    3. Друг, который вам помогает, должен быть новым пользователем, иначе вы не сможете получить помощь. (Каждый новый пользователь может помочь только один раз) <br/>
    4. Если вы хотите помочь своему другу, откройте ссылку, отправленную вам другом, скопируйте код друга и введите код перед тем, как нажать на помощь. (Если код не введен или он неверный, вы не сможете помочь)
    `,
    noNull: 'Не может быть пустым',
    noHelp: 'Не могу помочь, вы не новый пользователь',
    noCode: 'Неверный код приглашения',
    hadHelp: 'Уже помог',
    sucHelp: 'Помощь успешна',
    getSuc: 'Получено успешно',
    copySuc: 'Копирование успешно',
    dl: 'Скачать',
    cuUser: 'Текущее количество приглашенных',
    enterI: 'Введите код приглашения',
    friendI: 'Код приглашения друга',
    clickHelp: 'Нажмите, чтобы помочь',
    meAlso: 'Я тоже хочу получить награду',
    meAlso2: 'Я тоже хочу принять участие',
    acShow: 'Отображение награды мероприятия',
    rule: 'Правила',
    letgo: 'Войдите в Yayya и помогите своим друзьям!'
  },
  fa: {
    ruleContent: `
    1. 8 دوست خود را دعوت کنید، 5 تکه به دست آورید و یک قاب آواتار اضافی (15 روز) بگیرید <br/>
    2. تکه‌ها می‌توانند به فعالیت‌های پازل بروند، پازل‌ها را باز کنند و جوایز را تعویض کنند <br/>
    3. دوستی که به شما کمک می‌کند باید یک کاربر جدید باشد، در غیر این صورت نمی‌توانید کمک کنید. (هر کاربر جدید فقط یک بار می‌تواند کمک کند) <br/>
    4. اگر می‌خواهید به دوست خود کمک کنید، پیوند ارسال شده توسط دوستتان را باز کنید، کد دوستتان را کپی کرده و قبل از کلیک روی کمک، کد را وارد کنید. (اگر کد وارد نشود یا کد اشتباه باشد، نمی‌توانید کمک کنید)
    `,
    noNull: 'نمی‌تواند خالی باشد',
    noHelp: 'نمی‌توانم کمک کنم، شما کاربر جدید نیستید',
    noCode: 'کد دعوت نادرست',
    hadHelp: 'قبلاً کمک کرده است',
    sucHelp: 'کمک موفقیت‌آمیز',
    getSuc: 'دریافت موفقیت‌آمیز',
    copySuc: 'کپی موفقیت‌آمیز',
    dl: 'دانلود',
    cuUser: 'تعداد دعوت‌شدگان فعلی',
    enterI: 'کد دعوت را وارد کنید',
    friendI: 'کد دعوت دوست',
    clickHelp: 'برای کمک کلیک کنید',
    meAlso: 'من هم می‌خواهم جایزه بگیرم',
    meAlso2: 'من هم می‌خواهم شرکت کنم',
    acShow: 'نمایش جوایز فعالیت',
    rule: 'قوانین',
    letgo: 'وارد Yayya شوید و به دوستان خود کمک کنید!'
  },
  tr: {
    ruleContent: `
    1. 8 arkadaşınızı davet edin, 5 parça kazanın ve ekstra bir avatar çerçevesi (15 gün) alın <br/>
    2. Parçalar, bulmaca aktivitelerine katılabilir, bulmacaları açabilir ve ödülleri değiştirebilir <br/>
    3. Yardımcı olabilecek arkadaşınızın yeni bir kullanıcı olması gerekir, aksi takdirde başarılı olamayacaksınız. (Her yeni kullanıcı yalnızca bir kez yardımcı olabilir) <br/>
    4. Arkadaşınıza yardım etmek isterseniz, arkadaşınızın gönderdiği bağlantıyı açın, arkadaşınızın kodunu kopyalayın ve Yardım'a tıklamadan önce kodu doldurun. (Kodu doldurmazsanız veya kod yanlışsa, yardım edemezsiniz)
    `,
    noNull: 'Boş olamaz',
    noHelp: 'Yardım edemem, yeni kullanıcı değilsiniz',
    noCode: 'Geçersiz davet kodu',
    hadHelp: 'Zaten yardımcı olundu',
    sucHelp: 'Yardım başarılı',
    getSuc: 'Başarıyla alındı',
    copySuc: 'Başarıyla kopyalandı',
    dl: 'İndir',
    cuUser: 'Mevcut davet edilen kullanıcı sayısı',
    enterI: 'Davet kodu girin',
    friendI: 'Arkadaş davet kodu',
    clickHelp: 'Yardım için tıklayın',
    meAlso: 'Ben de ödül almak istiyorum',
    meAlso2: 'Ben de katılmak istiyorum',
    acShow: 'Etkinlik ödülleri gösterimi',
    rule: 'Kurallar',
    letgo: "Yayya'ye girin ve arkadaşlarınıza yardım edin!"
  },
  pt: {
    ruleContent: `
    1. Convide 8 amigos, ganhe 5 fragmentos e ganhe um quadro de avatar extra (15 dias) <br/>
    2. Fragmentos podem ser usados em atividades de quebra-cabeça, desbloquear quebra-cabeças e trocar por recompensas <br/>
    3. O amigo que te ajudar deve ser um usuário novo, caso contrário, você não poderá ajudar com sucesso. (Cada novo usuário pode ajudar apenas uma vez) <br/>
    4. Se você quiser ajudar seu amigo, abra o link enviado pelo seu amigo, copie o código do amigo e preencha o código antes de clicar em Ajudar. (Se você não preencher o código ou o código estiver errado, não poderá ajudar)
    `,
    noNull: 'Não pode estar vazio',
    noHelp: 'Não posso ajudar, você não é um novo usuário',
    noCode: 'Código de convite inválido',
    hadHelp: 'Já ajudou',
    sucHelp: 'Ajuda bem-sucedida',
    getSuc: 'Recebido com sucesso',
    copySuc: 'Copiado com sucesso',
    dl: 'Baixar',
    cuUser: 'Número atual de convidados',
    enterI: 'Digite o código de convite',
    friendI: 'Código de convite do amigo',
    clickHelp: 'Clique para ajudar',
    meAlso: 'Eu também quero ganhar uma recompensa',
    meAlso2: 'Eu também gostaria de participar',
    acShow: 'Exibição de recompensas de atividade',
    rule: 'Regras',
    letgo: 'Entre no Yayya e ajude seus amigos!'
  },
  id: {
    ruleContent: `
    1. Undang 8 teman, dapatkan 5 pecahan, dan dapatkan bingkai avatar tambahan (15 hari) <br/>
    2. Pecahan dapat digunakan dalam kegiatan teka-teki, membuka teka-teki, dan menukarnya dengan hadiah <br/>
    3. Teman yang membantu Anda haruslah pengguna baru, jika tidak, Anda tidak akan berhasil membantu. (Setiap pengguna baru hanya bisa membantu sekali) <br/>
    4. Jika Anda ingin membantu teman Anda, buka tautan yang dikirim oleh teman Anda, salin kode teman Anda, dan masukkan kode sebelum mengklik Bantuan. (Jika Anda tidak mengisi kode atau kode salah, Anda tidak bisa membantu)
    `,
    noNull: 'Tidak boleh kosong',
    noHelp: 'Tidak bisa membantu, Anda bukan pengguna baru',
    noCode: 'Kode undangan tidak valid',
    hadHelp: 'Sudah membantu',
    sucHelp: 'Bantuan berhasil',
    getSuc: 'Diterima dengan sukses',
    copySuc: 'Disalin dengan sukses',
    dl: 'Unduh',
    cuUser: 'Jumlah undangan yang ada saat ini',
    enterI: 'Masukkan kode undangan',
    friendI: 'Kode undangan teman',
    clickHelp: 'Klik untuk membantu',
    meAlso: 'Saya juga ingin mendapatkan hadiah',
    meAlso2: 'Saya juga ingin ikut serta',
    acShow: 'Tampilan hadiah aktivitas',
    rule: 'Aturan',
    letgo: 'Masuk ke Yayya dan bantu teman-teman Anda!'
  }
}



// WEBPACK FOOTER //
// src/pages/activity/ramadanHelp/lang.js